import { useLoggedUserContext } from '../AppContext';
import LoadingPopup from './loading/LoadingPopup';
import { useMutation } from "@tanstack/react-query";
import ErrorPopup from "./error/ErrorPopup";
import { useNavigate } from "react-router-dom";
import userClient from '../infrastructure/userClient';
import "./TopPanel.css";

export default function TopPanel() {
    const [loggedUser, setLoggedUser] = useLoggedUserContext();
    const navigate = useNavigate();

    const logOutQuery = useMutation({mutationFn: () => userClient.logOut()});
    if (logOutQuery.isSuccess) {
        setTimeout(() => {
            setLoggedUser(null);
            navigate('/login');
        });
    }

    return <div className='panel topPanel'>
        {logOutQuery.isError && <ErrorPopup message={logOutQuery.error.message}/>}
        {(logOutQuery.isPending || logOutQuery.isSuccess) ? <LoadingPopup/> : null} 
        <div className="buttons">
            <button onClick={() => logOutQuery.mutate()}>{loggedUser.login}</button>
        </div>
    </div>
}
